import { useEffect } from 'react';
import usePortalOpo from '@nkr/store/opo/hooks/use-portal-opo';
import SettingsTabs, { adminOnlySettingsTabs, getDefaultSettingsTab, SettingsTab } from './tabs';
import { TabPanel } from '../tab-styles';
import AdminSettings from './admin';
import ProfileSettings from './profile';
import PortalUsers from './users';
import OpoAddresses from './addresses';
import OpoContacts from './contacts';
import OpoPackaging from './packaging';
import TaxSettings from './taxes';

interface IProps {
    activeTab: string,
    onTabSelect: (tab: SettingsTab) => void
}

const SettingsContent = ({ activeTab, onTabSelect }: IProps) => {
    const { isAdmin } = usePortalOpo();
    const isBlocked = !isAdmin && adminOnlySettingsTabs.indexOf(activeTab) >= 0;

    useEffect(() => {
        if (isBlocked) {
            onTabSelect(getDefaultSettingsTab(isAdmin));
        }
    }, [isBlocked]);

    if (isBlocked) {
        return null;
    }

    return (
        <>
            <SettingsTabs activeKey={activeTab} isAdmin={isAdmin} onSelect={onTabSelect} />
            <TabPanel role='tabpanel'>
                {activeTab == SettingsTab.Admin && (
                    <AdminSettings />
                )}

                {activeTab == SettingsTab.Taxes && (
                    <TaxSettings />
                )}

                {activeTab == SettingsTab.Profile && (
                    <ProfileSettings />
                )}

                {activeTab == SettingsTab.PortalUsers && (
                    <PortalUsers />
                )}

                {activeTab == SettingsTab.Addresses && (
                    <OpoAddresses />
                )}

                {activeTab == SettingsTab.Contacts && (
                    <OpoContacts />
                )}

                {activeTab == SettingsTab.Packaging && (
                    <OpoPackaging />
                )}
            </TabPanel>
        </>
    );
}

export default SettingsContent;
